<template>
  <svg width="1289" height="180" viewBox="0 0 1289 180" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M303.482 18.8054C297.805 13.1248 297.805 3.90554 303.482 -1.79833L353.946 -52.295C359.623 -57.9756 368.836 -57.9756 374.537 -52.295C380.213 -46.6144 380.213 -37.3951 374.537 -31.6912L324.073 18.8054C318.396 24.486 309.182 24.486 303.482 18.8054Z"
      fill="url(#paint0_linear_228_29735)" />
    <path
      d="M839.578 43.6183C834.972 39.0086 834.972 31.5354 839.578 26.949L880.457 -13.9558C885.063 -18.5655 892.532 -18.5655 897.115 -13.9558C901.722 -9.34619 901.722 -1.87297 897.115 2.7134L856.237 43.6183C851.63 48.2279 844.162 48.2279 839.578 43.6183Z"
      fill="url(#paint1_linear_228_29735)" />
    <path
      d="M620.529 171.026C617.343 167.841 617.343 162.696 620.529 159.51L714.029 66.0098C717.215 62.8242 722.36 62.8242 725.545 66.0098C728.731 69.1953 728.731 74.3402 725.545 77.5257L632.045 171.026C628.859 174.212 623.714 174.212 620.529 171.026Z"
      fill="url(#paint2_linear_228_29735)" />
    <path
      d="M1236.14 144.958C1232.32 148.775 1232.32 154.94 1236.14 158.757L1271.51 194.131C1275.33 197.947 1281.5 197.947 1285.31 194.131C1289.13 190.314 1289.13 184.149 1285.31 180.332L1249.94 144.958C1246.12 141.142 1239.96 141.142 1236.14 144.958Z"
      fill="url(#paint3_linear_228_29735)" />
    <path
      d="M3.44322 198.705C-0.37365 194.888 -0.37365 188.724 3.44322 184.907L38.8171 149.533C42.634 145.716 48.7984 145.716 52.6153 149.533C56.4321 153.35 56.4321 159.514 52.6153 163.331L17.2414 198.705C13.4245 202.522 7.26008 202.522 3.44322 198.705Z"
      fill="url(#paint4_linear_228_29735)" />
    <path
      d="M687.338 183.846L747.062 169.993C758.16 167.409 768.095 177.373 765.535 188.479L751.692 248.241C748.97 260.021 734.359 264.189 725.82 255.644L679.963 209.757C671.424 201.213 675.612 186.593 687.362 183.869L687.338 183.846Z"
      fill="url(#paint5_linear_228_29735)" />
    <path
      d="M1077.12 56.7378C1060.63 56.7378 1047.27 70.1011 1047.27 86.6074C1047.27 103.114 1060.63 116.477 1077.12 116.477C1093.62 116.477 1106.97 103.114 1106.97 86.6074C1106.97 70.1011 1093.62 56.7378 1077.12 56.7378ZM1077.12 112.473C1062.84 112.473 1051.25 100.879 1051.25 86.5841C1051.25 72.2896 1062.84 60.6956 1077.12 60.6956C1091.41 60.6956 1103 72.2896 1103 86.5841C1103 100.879 1091.41 112.473 1077.12 112.473Z"
      fill="url(#paint6_linear_228_29735)" />
    <path
      d="M933.836 164.911C926.057 164.911 919.759 171.208 919.759 178.987C919.759 186.766 926.057 193.063 933.836 193.063C941.614 193.063 947.912 186.766 947.912 178.987C947.912 171.208 941.614 164.911 933.836 164.911ZM933.836 191.176C927.099 191.176 921.635 185.713 921.635 178.976C921.635 172.24 927.099 166.776 933.836 166.776C940.572 166.776 946.036 172.24 946.036 178.976C946.036 185.713 940.572 191.176 933.836 191.176Z"
      fill="url(#paint7_linear_228_29735)" />
    <path
      d="M282.969 144.587C285.147 135.325 279.409 126.05 270.153 123.871C260.897 121.692 251.628 127.434 249.451 136.696C247.273 145.957 253.011 155.232 262.266 157.411C271.522 159.59 280.791 153.849 282.969 144.587Z"
      fill="url(#paint8_linear_228_29735)" />
    <defs>
      <linearGradient id="paint0_linear_228_29735" x1="384.797" y1="-62.5387" x2="315.047" y2="7.14292"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#FFC255" />
        <stop offset="1" stop-color="#FF229B" />
      </linearGradient>
      <linearGradient id="paint1_linear_228_29735" x1="839.043" y1="44.1537" x2="903.532" y2="-20.3163"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#AF1B65" />
        <stop offset="1" stop-color="#FF229B" />
      </linearGradient>
      <linearGradient id="paint2_linear_228_29735" x1="619.556" y1="171.999" x2="737.181" y2="54.3739"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#FFC255" />
        <stop offset="1" stop-color="#FF229B" />
      </linearGradient>
      <linearGradient id="paint3_linear_228_29735" x1="1235.69" y1="144.511" x2="1290.76" y2="199.576"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#FFC255" />
        <stop offset="1" stop-color="#FF229B" />
      </linearGradient>
      <linearGradient id="paint4_linear_228_29735" x1="2.99605" y1="199.152" x2="58.0611" y2="144.087"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#FFC255" />
        <stop offset="1" stop-color="#FF229B" />
      </linearGradient>
      <linearGradient id="paint5_linear_228_29735" x1="675.426" y1="214.856" x2="765.931" y2="214.856"
        gradientUnits="userSpaceOnUse">
        <stop stop-color="#FFC255" />
        <stop offset="1" stop-color="#FF229B" />
    </linearGradient>
    <linearGradient id="paint6_linear_228_29735" x1="1047.27" y1="86.6074" x2="1106.97" y2="86.6074"
      gradientUnits="userSpaceOnUse">
      <stop stop-color="#FFC255" />
      <stop offset="1" stop-color="#FF229B" />
    </linearGradient>
    <linearGradient id="paint7_linear_228_29735" x1="919.759" y1="178.987" x2="947.912" y2="178.987"
      gradientUnits="userSpaceOnUse">
      <stop stop-color="#FFC255" />
      <stop offset="1" stop-color="#FF229B" />
    </linearGradient>
    <linearGradient id="paint8_linear_228_29735" x1="248.991" y1="140.64" x2="283.424" y2="140.64"
      gradientUnits="userSpaceOnUse">
      <stop stop-color="#FFC255" />
      <stop offset="1" stop-color="#FF229B" />
    </linearGradient>
  </defs>
</svg></template>

<script>
export default {
  name: "OffersBannerItem2",
};
</script>